import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  DestroyRef,
  ChangeDetectorRef
} from '@angular/core';
import { PitchCardModalBase } from '../pitchcard-modal-base';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-pitchcard-more-info-modal',
  standalone: true,

  imports: [CommonModule, DialogModule, TranslateModule],
  templateUrl: './pitchcard-more-info-modal.component.html'
})
export class PitchCardMoreInfoModalComponent extends PitchCardModalBase {
  @Input() showMoreInfoDialog: any;
  @Input() currentPitchCard: any;
  @Input() currentPitchCardType: any;
  @Input() moreInfoWorkingHours: any;
  @Input() isEmbedded: any;
  @Input() isMobile: any;
  @Input() isPortraitMode: any;
  @Input() uniqueId: string;

  validateLink(link: string) {
    if (link) {
      return (link && link.includes('https')) || (link && link.includes('http'))
        ? link
        : 'https://' + link;
    }
    return '#';
  }
}
